export const ReactiveOwnerProperty = Symbol("Reactive owner property used by tiptap solid as a workaround");
// Solid js doesn't expose Owner type so use any instead
export const getTiptapSolidReactiveOwner = (editor) => editor[ReactiveOwnerProperty] ?? undefined;
